"use strict";

var moment = require('moment-timezone');

var locale = 'America/New_York';

function getClientShipDate(order) {
  var letterpressShipDate;
  var printingPlusShipDate;
  var printDateLetterpress;
  var printDate;
  var dateString = 'ddd MMM DD YYYY';
  var approved_on_date = order.approved_on_date === '' ? moment().tz(locale) : order.approved_on_date;
  var today = moment(approved_on_date);
  var daysToPrintLetterpress = 12;

  if (moment(approved_on_date).tz(locale).hours() >= 17) {
    daysToPrintLetterpress++;
  }

  if (order.printing_type.match(/RUSH/i)) {
    daysToPrintLetterpress = 6;

    if (moment(approved_on_date).tz(locale).hours() >= 16) {
      daysToPrintLetterpress++;
    }
  }

  if (order.has_letterpress && order.is_international) {
    printDate = today.businessAdd(daysToPrintLetterpress);
    printingPlusShipDate = printDate.format(dateString);
  } else {
    if (order.has_letterpress) {
      printDateLetterpress = today.businessAdd(daysToPrintLetterpress);
      letterpressShipDate = printDateLetterpress.format(dateString);
    }

    var daysToPrint = 6;

    if (moment(approved_on_date).tz(locale).hours() >= 17) {
      daysToPrint++;
    }

    if (order.printing_type.match(/1 DAY/i)) {
      if (moment(approved_on_date).tz(locale).hours() >= 12) {
        daysToPrint = 2;
      } else {
        daysToPrint = 1;
      }
    } else if (order.printing_type.match(/2 DAY/i)) {
      if (moment(approved_on_date).tz(locale).hours() >= 17) {
        daysToPrint = 4;
      } else {
        daysToPrint = 3;
      }
    }

    printDate = today.businessAdd(daysToPrint);
    printingPlusShipDate = printDate.format(dateString);
  }

  return {
    printingPlusShipDate: printingPlusShipDate,
    letterpressShipDate: letterpressShipDate,
    pistachioPressShipDateObject: printDateLetterpress,
    printingPlusShipDateObject: printDate
  };
}

module.exports = getClientShipDate;